<form [formGroup]="assetUploadEditorForm">
  <!-- this uploader is only used for brand logos -->
  @if(assetUploadEditorForm.controls.id.value === null && isBrandLogoMode){
      <div class="row form-group">
      <div class="col-12">
        <div class="control_wrapper">
          <div class='imagepreview'>
            <div #dropArea id='dropArea'>
              <ejs-uploader #defaultupload
                            id="certificateMedia"
                            multiple="false"
                            [ngClass]="{'invalidDropArea': !assetUploadEditorForm.controls.base64FileData.valid && assetUploadEditorForm.controls.base64FileData.touched}"
                            [allowedExtensions]="allowedExtensions"
                            [dropArea]="dropArea"
                            [autoUpload]="false"
                            (removing)="onFileRemove($event)"
                            (selected)="handleFileInput($event)">
              </ejs-uploader>
              <app-error-messages [control]="assetUploadEditorForm.controls.base64FileData"></app-error-messages>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="row form-group">
    <div class="col-6">
      <label for="publicName" class="control-label required">{{
        'i18n.domain.assets.product-assets.edit-asset.public-name' | translate }}</label>
      <input id="publicName" type="text" class="form-control" formControlName="publicName" />
      <app-error-messages [control]="assetUploadEditorForm.controls.publicName"></app-error-messages>
    </div>
    <div class="col-6">
      <label for="fileExtension" class="control-label">{{ 'i18n.domain.assets.product-assets.edit-asset.file-name-extension' | translate }}</label>
      <input id="fileExtension" type="text" class="form-control" formControlName="fileExtension"/>
      <app-error-messages [control]="assetUploadEditorForm.controls.fileExtension"></app-error-messages>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-6">
      <label class="control-label required">{{ 'i18n.domain.assets.product-assets.edit-asset.shops' | translate
        }}</label>
      <ejs-multiselect id='shopIds' [dataSource]='shopIds' formControlName="shopIds"></ejs-multiselect>
      <app-error-messages [control]="assetUploadEditorForm.controls.shopIds"></app-error-messages>
    </div>
    @if(!isBrandLogoMode){
      <div class="col-6">
        <label class="control-label required">{{'i18n.domain.assets.product-assets.edit-asset.asset-type' |
          translate}}</label>
        <ejs-dropdownlist #typeDropdown [dataSource]="assetTypes" [fields]="enumDropdownSettings" id="type"
          formControlName="type">
          <ng-template #itemTemplate let-data>
            {{data.text | translate}}
          </ng-template>
          <ng-template #valueTemplate let-data>
            <div class="centered">
              <span>{{data.text | translate}}</span>
            </div>
          </ng-template>
        </ejs-dropdownlist>
        <app-error-messages [control]="assetUploadEditorForm.controls.type"></app-error-messages>
      </div>
    }
  </div>
  <div class="row form-group">
    @if(!isBrandLogoMode){
      <div class="col-6">
        <label class="control-label"
          [ngClass]="{'required': !isLogoTypeSelected && !isImageTypeSelected}">{{'i18n.domain.assets.product-assets.edit-asset.language'
          | translate}}</label>
        <ejs-dropdownlist [dataSource]="languages" id="language" formControlName="language">
          <ng-template #itemTemplate let-data>
            {{data}}
          </ng-template>
          <ng-template #valueTemplate let-data>
            <div class="centered">
              <span>{{data}}</span>
            </div>
          </ng-template>
        </ejs-dropdownlist>
        <app-error-messages [control]="assetUploadEditorForm.controls.language"></app-error-messages>
      </div>
    }
    @if(assetUploadEditorForm.controls.id.value === null){
      <div class="col-6">
        <label class="control-label required">{{ 'i18n.domain.assets.product-assets.edit-asset.is-key' | translate
          }}</label>
        <app-yes-no-group-button id="isKey" formControlName="isKey"></app-yes-no-group-button>
      </div>
    }
  </div>
  @if(isBrandLogoMode){
    <div class="row form-group mt-55">
      <div class="col-3">
        <label class="control-label mr-2 toggle-label">{{
          'i18n.domain.assets.product-assets.edit-asset.replace-product-logos' | translate }}</label>
      </div>
      <div class="col-3">
        <ejs-switch #replaceProductLogos formControlName="replaceProductLogos"
          (change)="replaceProductLogosSwitched()"></ejs-switch>
      </div>
    </div>
  }
  @if(isBrandLogoMode){
    <div class="row form-group">
      <div class="col-3">
        <label class="control-label mr-2 toggle-label">{{
          'i18n.domain.assets.product-assets.edit-asset.replace-customized-logos' | translate }}</label>
      </div>
      <div class="col-3">
        <ejs-switch #replaceCustomizedLogos formControlName="replaceCustomizedLogos"></ejs-switch>
      </div>
    </div>
  }
  <div class="row form-group">
    <div class="col-6">
      <label class="control-label mr-2 toggle-label">{{
        'i18n.domain.assets.product-assets.edit-asset.original-file-name' | translate }}</label>
        <input id="originalFileName" type="text" class="form-control" formControlName="originalFileName" />
    </div>
    <div class="col-6">
      <label class="control-label mr-2 toggle-label">{{
        'i18n.domain.assets.product-assets.edit-asset.alt-text' | translate }}</label>
        <input id="altText" type="text" class="form-control" formControlName="altText" />
    </div>
  </div>
</form>
